/**
 * 模块：系统事件报警
 * 作者：haikuo.zhang
 * 时间：2021-09-14
 */

import {KecPath, Service, Version, source} from './constants';

export const DescribeInstanceSystemEvents = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'DescribeInstanceSystemEvents',
        Service,
        Version: '2021-01-01',
        source
    }
};
export const ModifyInstanceMaintenanceAttribute = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'ModifyInstanceMaintenanceAttribute',
        Service,
        Version,
        source
    }
};
